import React, { useRef } from 'react';
import { ReactComponent as IconCross } from 'assets/icons/cross-icon.svg';

import { MultiSelect, SelectOption } from 'common.ui';
import './ResponsiblePersonsMultiSelect.scss';

type ResponsiblePersonsMultiSelectProps = {
  options: SelectOption[];
  selectedIds: string[];
  name: string;
  label: string;
  okLabel: string;
  onChange?: (model: string[]) => void;
  onSelectionChange?: (val: string[]) => void;
  ignoreClicksOutside?: boolean;
  onClose?: () => void;
  triggerOnChangeAlways?: boolean; // Trigger onChange when closing even if values are the same
  isInitiallyOpen?: boolean; // MultiSelect is initally open and options expanded
};

function ResponsiblePersonsMultiSelect({
  options,
  selectedIds,
  name,
  label,
  okLabel,
  triggerOnChangeAlways,
  isInitiallyOpen,
  onSelectionChange,
  onChange: onChangeCallBack,
  onClose,
  ignoreClicksOutside
}: ResponsiblePersonsMultiSelectProps) {
  // const applicationFilter = '';
  const containerRef = useRef(null);

  return (
    <div className='responsiblePersons-multiselect-container' ref={containerRef}>
      <IconCross style={{ float: 'right', width: '8px' }} onClick={onClose} className='close-multiselect' />
      <b>Filtrer utvalg på:</b>

      <MultiSelect
        label={label}
        okLabel={okLabel}
        id={name}
        triggerOnChangeAlways={triggerOnChangeAlways}
        isInitiallyOpen={isInitiallyOpen}
        ignoreClicksOutside={ignoreClicksOutside}
        onSelectionChange={onSelectionChange}
        onChange={(model: string[]) => {
          if (onChangeCallBack) onChangeCallBack(model);
        }}
        options={options.map((o) => ({
          id: o.id ?? '',
          text: o.text ?? ''
        }))}
        selectedIds={selectedIds}
        doNotDisplayOptionsOnTop
        wrapperRef={containerRef}
      />
    </div>
  );
}

export { ResponsiblePersonsMultiSelect };
